<template>
  <div class="step-tab">
    <div class="cp-card">
      <p class="cp-hint">{{ L.overview_step_hint || 'The trip summary sidebar is shown to the right of every checkout step. Here you decide whether it lists the down payment and remaining balance under the total.' }}</p>
      <BoxVisibilityToggle
          :boxVisibility="profile.box_visibility"
          boxKey="summary_deposit"
          :label="L.review_box_summary_deposit || 'Down payment & remaining balance'"
          :hint="L.box_toggle_summary_deposit_hint || 'Anzahlung/Restzahlung rows under the total. Display only — the charged amount is unchanged.'" />
    </div>

    <PreviewFrame :label="L.preview || 'Preview'">
      <OverviewPreview :lang="lang" :brandColor="brandColor" :boxVisibility="profile.box_visibility" />
    </PreviewFrame>
  </div>
</template>

<script>
import PreviewFrame from './previews/PreviewFrame.vue'
import OverviewPreview from './previews/OverviewPreview.vue'
import BoxVisibilityToggle from './BoxVisibilityToggle.vue'

/**
 * Trip Overview (Reiseübersicht) tab: configures the trip-summary sidebar that
 * accompanies every checkout step. Only the Anzahlung/Restzahlung rows are
 * profile-configurable (summary_deposit box); prices themselves come from Nezasa.
 */
export default {
  name: 'StepTabOverview',
  components: { PreviewFrame, OverviewPreview, BoxVisibilityToggle },
  props: {
    options: { type: Object, required: true },
    profile: { type: Object, required: true },
    lang: { type: String, default: 'de' },
    brandColor: { type: String, default: '#1a73e8' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  }
};
</script>

<style scoped>
.step-tab { animation: cp-fade .2s ease; }
@keyframes cp-fade { from { opacity: 0; transform: translateY(4px); } to { opacity: 1; transform: translateY(0); } }
.cp-card { background: #fff; border-radius: 1rem; box-shadow: 0 2px 12px rgba(0,0,0,0.06); padding: 1.5rem 1.75rem; }
.cp-hint { font-size: 0.8rem; color: #888; margin: 0 0 1rem; max-width: 620px; }
</style>
